export const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api',
  DEFAULT_COUNTRY_CODE: 'tw', // Single region - Taiwan hardcoded
} as const;
